import { postRequest } from '@/core';
import { orderTemplates } from '@/requests';

export default async function getGeneratedOrdersRequest(orderIds) {
	let url = orderTemplates.getGeneratedOrdersPath();
	let generatedOrders = await postRequest(url, {}, orderIds);
	return generatedOrders;
}